import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthenticationService } from '../services/authentication.service';
import { IMy7nEnvConfig } from '../interfaces/my7n-env-config';
import { MY7N_ENV_CONFIG } from '../functions/my7n-env-config';
import { Inject } from '@angular/core';

@Injectable()
export class BearerTokenInterceptor implements HttpInterceptor {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private authService: AuthenticationService,
    @Inject(MY7N_ENV_CONFIG) private envConfig: IMy7nEnvConfig
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isSecureRoute = this.envConfig.allowedUrls?.some((url) => req.url.startsWith(url));
    console.log('[BearerTokenInterceptor] isSecureRoute:', isSecureRoute, 'allowedUrls:', this.envConfig.allowedUrls);

    if (!isSecureRoute) {
      return next.handle(req);
    }

    return this.oidcSecurityService.getAccessToken(this.authService.activeConfigId).pipe(
      take(1),
      switchMap((token) => {
        console.log('[BearerTokenInterceptor] activeConfigId:', this.authService.activeConfigId, 'token exists:', !!token);

        if (token) {
          console.log('[BearerTokenInterceptor] Adding Authorization header to request:', req.url);
          req = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          });
        }

        return next.handle(req);
      })
    );
  }
}
